export default __webpack_public_path__ + "static/media/facebook.fdcd32b9.svg";